// extracted by mini-css-extract-plugin
export default {"container":"Step1_container__BB7oE","points":"Step1_points__9YnL-","text":"Step1_text__VdTz9"};